import { apiSlice } from "../apiSlice";

export const currentCapitalApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentCapital: builder.query({
      query: () => `/current-capital`,
      keepUnusedDataFor: 600,
      providesTags: () => [{ type: "currentCapital" }],
    }),
  }),
});
export const { useGetCurrentCapitalQuery } = currentCapitalApi;
